import { render, staticRenderFns } from "./WereYouReferred.vue?vue&type=template&id=2307d2a6&"
import script from "./WereYouReferred.vue?vue&type=script&lang=ts&"
export * from "./WereYouReferred.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports